import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'billability-calculator',
    description: 'Simple billability calculator',
    icon: 'calculator',
    name: 'Billability Calculator',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
